// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__E-Zm0","list":"PatternAutocomplete_list__2KRPS"};